var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.9 32",
    style: {
      enableBackground: "new 0 0 38.9 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D9BF0",
    d: "M35.2,7.5c0,0.3,0,0.7,0,1c0,10.7-8.1,23-23,23v0c-4.4,0-8.7-1.3-12.4-3.6 C0.5,28,1.1,28,1.8,28c3.6,0,7.2-1.2,10-3.5c-3.5-0.1-6.5-2.3-7.5-5.6c1.2,0.2,2.5,0.2,3.6-0.1c-3.8-0.8-6.5-4.1-6.5-7.9 c0,0,0-0.1,0-0.1c1.1,0.6,2.4,1,3.7,1C1.5,9.4,0.4,4.7,2.6,1c4.1,5,10.2,8.1,16.7,8.4c-0.7-2.8,0.2-5.7,2.3-7.7 C24.8-1.4,29.9-1.2,33,2c1.8-0.4,3.5-1,5.1-2c-0.6,1.9-1.9,3.5-3.6,4.5c1.6-0.2,3.2-0.6,4.6-1.3C38.1,4.9,36.8,6.3,35.2,7.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.279e44ba75788a11bde162828490119a.svg";
export { ForwardRef as ReactComponent };